import { autoinject } from "aurelia-dependency-injection";
import { FeatureInfo } from "./freemium-feature-info-model";
import { ConfigService } from "../../services/basic/config.service";
import { DialogClientService } from "../../services/basic/dialog-client.service";

//Load styles
require("./dialog-upgrade-from-freemium.scss");

@autoinject()
export class DialogUpgradeFromFreemium {

    public featureInfo: FeatureInfo;

    constructor(private dialogClientService: DialogClientService, private configService: ConfigService) {}

    activate(featureInfo: FeatureInfo){
        this.featureInfo = featureInfo;
    }

    close() {
        this.dialogClientService.hide();
    }

    upgradeNow() {
        window.open(this.configService.config.urls.rightStoreRightshipSubscriptionUrl, '_blank');
    }
}